import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    width: "100%",
    display: "flex",
    marginLeft: "12px",
    marginBottom: "7px",
    flexDirection: "column",
    "& .MuiAlert-message": {
      padding: theme.spacing(1.5),
      fontSize: "0.875rem",
      color: "#626262",
    },
  },
  approve: {
    backgroundColor: "#EEF6F1",
    border: "1px solid #16A14A",
    borderLeft: "4px solid #16A14A",
    color: "#16A14A",
    "& .MuiAlertTitle-root": {
      color: "#16A14A",
      fontWeight: 600,
    },
  },
  reject: {
    backgroundColor: "#FFF5F5",
    border: "1px solid #EF4443",
    color: "#EF4443",
    borderLeft: "4px solid #EF4443",
    "& .MuiAlertTitle-root": {
      color: "#EF4443",
      fontWeight: 600,
    },
  },
}));

const CommentNotification = ({ comment, type }) => {
  const classes = useStyles();

  if (!comment) return null;

  const className = type === "approve" ? classes.approve : classes.reject;
  const title = type === "approve" ? "Approval Comment" : "Rejection Comment";

  return (
    <Alert
      severity={type === "approve" ? "success" : "error"}
      variant="outlined"
      className={`${classes.root} ${className}`}
      icon={false}
    >
      <AlertTitle>{title}</AlertTitle>
      {comment}
    </Alert>
  );
};

export default CommentNotification;
